<template>
  <div class="block__profile-collab" >

    <!-- ENTETE -->
    <div class="mobile">
      <div class="link">
        <button class="bt btn-back" @click="goBack()">
            <font-awesome-icon :icon="['far', 'angle-left']"/>
        </button>
        <h3>{{general.profileTitleCollaborators}}</h3>
      </div>
      <div class="sep"></div>
    </div>
    <!-- ENTETE -->



    <!-- CONTENT -->
    <div class="scrollable col">
      <h1>{{general.profileTitleCollaboratorsSave}}</h1>
      <p class="subtitle">{{general.profileTitleCollaboratorsSubTitle}}</p>

      <b-list-group>
       <PuSkeleton :loading="isLoading" :count="1" width='100%' height='2rem'>    
        <b-list-group-item data-target="1">
          Pierre Dujardin
          <div class="wrapper-button">
            <button class="bt-iconModify" @click.prevent="itemModify($event)">
                <font-awesome-icon :icon="['far', 'pencil-alt']"/>
            </button>
            <button class="bt-iconDelete" @click.prevent="itemDelete($event)">
              <font-awesome-icon :icon="['far', 'trash-alt']"/>
            </button>
          </div>
        </b-list-group-item>
       </PuSkeleton>
      </b-list-group>


      <router-link class="btn btn-add" :to="{ name: 'profileCollabAdd'}" v-if="isMobile">
        <font-awesome-icon :icon="['far', 'plus']"/>
        {{general.formBtAddCollab}}
      </router-link> 

      <button class="btn btn-add" v-b-toggle.sidebar-collaborateur v-else>
        <font-awesome-icon :icon="['far', 'plus']"/>
        {{general.formBtAddCollab}}
      </button> 

    </div>
    <!-- CONTENT -->



    <!-- SIDEBAR -->
    <b-sidebar id="sidebar-collaborateur" right shadow width="360px" v-if="!isMobile">
      <FormCollab></FormCollab>
    </b-sidebar>
    <!-- SIDEBAR -->

    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
    <transition name="modal" v-if="isMobile">      
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition> 
  <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->  

  </div>



</template>




<script>
import { mapGetters } from 'vuex'
import utils from '../../../Utils'
import FormCollab from '../../../module/modal/FormCollab'


export default {
  name:"profileCollab",
    components:{
      FormCollab
    }, 
    computed: {
      ...mapGetters([
        'getGeneral',
      ])
    },
    data () {
      return {
        general:"",
        isLoading:true,
        isMobile:false,    
      }
    },
    created (){
      this.general = this.getGeneral;
      this.isMobile = utils.isMobile();


    setTimeout(() => {
        this.isLoading = false;
      },2000)         
    },    
    methods : {
      goBack() {
        this.$router.push({name: "profileHome"});  
      }, 
      itemModify(e){
        console.log(this.getTarget(e));
      },     
      itemDelete(e){
        console.log(this.getTarget(e));
      },     
      getTarget(e){
        const $target = e.target.closest('.list-group-item');
        return $target.getAttribute('data-target');
      }
    }
};
</script>
